// 通过 request 方法调用的埋点

import { request } from '../request';

export default {
  sendFlexOffers: (data) => request('/api/flexoffer', 'get', data),
  paymentEnter: () => request('/api/customer/payment_enter', 'get', {}, { errorMsg: false }), // 用户进入payment页面日志。目的是记录支付页面访问次数 【1009032】
  // 发送 Pinterest API 埋点
  sendPinterest: (data) =>
    request('/api/public/pinterest_data_reporting', 'post', data, { errorMsg: false }),
};
